import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Smile({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Smile</title>
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9.5" cy="9.5" r="1.5" fill={color ?? 'currentColor'} />
      <circle cx="14.5" cy="9.5" r="1.5" fill={color ?? 'currentColor'} />
      <path
        d="M16.462 14.3936C15.2069 15.4319 13.6289 16 12 16C10.3711 16 8.79315 15.4319 7.53803 14.3936"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
